import styled from 'styled-components';

const Root = styled('em') `
  font-family: ${props => props.theme.fonts.museo};
  font-size: ${props => props.theme.fontSizes[14]};
  line-height: 20px;
`;

export { Root };
//# sourceMappingURL=styled.js.map
